import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PageType, EventHeaderTabType, ComponentName, SelectionChangeType, TimeFilter } from 'src/app/models/enums';
import { ISportRegionCompetitionSelection } from 'src/app/models/sportHierarchy/sportRegionCompetitionSelection.interface';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { QueryParamsService } from 'src/app/services/http/queryParams.service';
import { SportsService } from 'src/app/services/sports.service';
import { UtilityService } from 'src/app/services/util/utility.service';

@Component({
  selector: 'app-results-events-header',
  templateUrl: './results-events-header.component.html',
  styleUrls: ['./results-events-header.component.less']
})
export class ResultsEventsHeaderComponent implements OnInit, OnChanges, OnDestroy {

  public srcSelection: ISportRegionCompetitionSelection;
  public tabsType: EventHeaderTabType;
  public tabs: any[] = [];
  public title: string;
  public subtitle: string;
  public eventsNumber: number;
  public showNoEventsMessage = false;
  public eventHeaderTabTypeEnum = EventHeaderTabType;
  private subscription: Subscription = new Subscription();


  @Input()
  timeFilterValue: TimeFilter;

  viewConfigurations = ViewConfigurations;
  public isMobileView: boolean;

  constructor(
    private sportsService: SportsService,
    private queryParamService: QueryParamsService,
    private utilityService: UtilityService) {

    this.isMobileView = utilityService.mobileView;
    // add sports list loaded for other pages
    this.subscription.add(sportsService.srcSelectionChanged$.subscribe((x) => {
      if (x.callFrom === ComponentName.ResultEventsHeaderComponent) {
        return;
      }
      this.srcSelection = this.sportsService.sportRegionCompetitionSelection;
      // this.srcSelection = {
      //   sport: this.sportsService.sportRegionCompetitionSelection.sport,
      //   region: this.sportsService.sportRegionCompetitionSelection.region,
      //   competition: this.sportsService.sportRegionCompetitionSelection.competition,
      // };

      this.setSelectables(x.selectionChangeType);
    }));
  }

  ngOnInit(): void {
  }

  ngOnChanges() {
    if (this.timeFilterValue === TimeFilter.None) {
      this.showNoEventsMessage = true;
      return;
    }
  }

  backToTree() {
    this.queryParamService.pageType = PageType.Prematch;
  }

  private setSelectables(selctionsChangeType: SelectionChangeType) {
    this.showNoEventsMessage = false;
    switch (selctionsChangeType) {
      case SelectionChangeType.Sport:
        {
          this.showNoEventsMessage = false;
          const sport = this.srcSelection.sport;
          if (!sport) {
            this.showNoEventsMessage = true;
            return;
          }
          this.tabsType = EventHeaderTabType.Region;
          this.tabs = sport.regions;
          this.title = sport.name;
          this.subtitle = '';
          this.eventsNumber = sport.eventsCount;
        }
        break;
      case SelectionChangeType.Region:
        {
          const region = this.srcSelection.region;
          if (!region) {
            this.showNoEventsMessage = true;
            return;
          }

          this.title = region.name;

          this.eventsNumber = region.eventsCount;
          this.subtitle = this.srcSelection.sport.name;
          this.tabs = region.competitions;
          if (ViewConfigurations.showAllEventsButtonOnSelectedRegion) {
            this.tabsType = EventHeaderTabType.RegionAndCompetitions;
            this.tabs = [region, ...this.tabs];
          }
        }
        break;
      case SelectionChangeType.Competition:
        {
          if (this.srcSelection.competition) {
            this.tabsType = EventHeaderTabType.Competition;
            this.tabs = this.srcSelection.region.competitions;
            this.title = this.srcSelection.region.name;
            this.eventsNumber = this.srcSelection.region.eventsCount;
            this.subtitle = this.srcSelection.sport.name;
            if (ViewConfigurations.showAllEventsButtonOnSelectedRegion) {
              this.tabsType = EventHeaderTabType.RegionAndCompetitions;
              this.tabs = [this.srcSelection.region, ...this.tabs];
            }
          }
        }
        break;
    }
  }

  selectTab(tab: any, justNotify: boolean = false) {
    if (tab.isSelected && !justNotify) {
      return;
    }

    if (!justNotify) {
      for (const t of this.tabs) {
        t.isSelected = false;
      }

      tab.isSelected = true;
    }

    switch (this.tabsType) {
      case EventHeaderTabType.Competition:
        this.sportsService.selectCompetitionNotify(tab, this.srcSelection.region, this.srcSelection.sport, false, ComponentName.ResultEventsHeaderComponent);
        break;
      case EventHeaderTabType.RegionAndCompetitions:
        if (tab.competitions) {
          // added for cro because in same type we also have region and competitions
          this.sportsService.selectRegionNotify(tab, this.srcSelection.sport, false, ComponentName.ResultEventsHeaderComponent);
        } else {
          this.sportsService.selectCompetitionNotify(tab, this.srcSelection.region, this.srcSelection.sport, false, ComponentName.ResultEventsHeaderComponent);
        }
        break;
      case EventHeaderTabType.Region:
        this.sportsService.selectRegionNotify(tab, this.srcSelection.sport, false, ComponentName.ResultEventsHeaderComponent);
        break;
      case EventHeaderTabType.Sport:
        this.sportsService.selectSportNotify(tab, false, ComponentName.ResultEventsHeaderComponent);
        break;
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
